$(document).ready(function () {
  $('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    focusOnSelect: true
  });

  $('.collection-nav').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 4000,
    focusOnSelect: true,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 3,
        }
      },
       {
        breakpoint: 767, 
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 2
        }
      }
    ],
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Group_4.svg?v=1765802268" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Group_5.svg?v=1765802265" alt="Next"></button>'
  });

  $('.brands-slide').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    speed: 6000,              
    autoplay: true,
    autoplaySpeed: 0,        
    cssEase: 'linear',    
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
     responsive: [
      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 575, 
        settings: {
          slidesToShow: 2
        }
      }
    ],
    swipe: false,
    draggable: false
  });

  function initMobileSlider() {
    if ($(window).width() < 767) {

      if (!$('.icon-boxes-slider').hasClass('slick-initialized')) {
        $('.icon-boxes-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          responsive: [
      {
        breakpoint: 575, 
        settings: {
          slidesToShow: 2,
        }
      }
    ],
          autoplaySpeed: 4000,
          focusOnSelect: true,
        });
      }

    } else {

      if ($('.icon-boxes-slider').hasClass('slick-initialized')) {
        $('.icon-boxes-slider').slick('unslick');
      }

    }
  }
  initMobileSlider();
  $(window).on('resize', initMobileSlider);

  /******** cstm filter show *********/ 
  $('ul.filter-list').hide();
  $('.filter-header').click(function (e) {
      e.preventDefault();
      $('ul.filter-list').slideToggle();
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById(tab.dataset.tab).classList.add("active");
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const PLUS_ICON = 'https://cdn.shopify.com/s/files/1/0997/6522/3755/files/plus.svg?v=1766149492';
  const MINUS_ICON = 'https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Line_3.svg?v=1766149632';

  document.querySelectorAll('.static-faq__question').forEach(btn => {
    // Create icon
    const icon = document.createElement('span');
    icon.className = 'static-faq__icon';
    icon.innerHTML = `<img src="${PLUS_ICON}" alt="plus">`;
    btn.appendChild(icon);

    btn.addEventListener('click', function () {
      const currentItem = btn.closest('.static-faq__item');
      if (!currentItem) return;

      const isOpen = currentItem.classList.contains('active');

      // Close all open FAQs
      document.querySelectorAll('.static-faq__item.active').forEach(item => {
        item.classList.remove('active');
        const itemIcon = item.querySelector('.static-faq__icon img');
        if (itemIcon) {
          itemIcon.src = PLUS_ICON;
          itemIcon.alt = 'plus';
        }
      });

      // Open clicked one (if it was closed)
      if (!isOpen) {
        currentItem.classList.add('active');
        icon.querySelector('img').src = MINUS_ICON;
        icon.querySelector('img').alt = 'minus';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Handle the checkbox selection for upsell products
  const upsellCheckboxes = document.querySelectorAll('.upsell-checkbox');

  upsellCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      const productId = this.dataset.productId;
      const variantId = this.dataset.variantId;
      const quantity = this.dataset.quantity;

      if (this.checked) {
        // Add selected upsell product to cart
        addUpsellProductToCart(variantId, quantity);
      }
    });
  });

  // Handle adding the upsell product to cart using AJAX
  function addUpsellProductToCart(variantId, quantity) {
    const data = {
      items: [{
        id: variantId,
        quantity: parseInt(quantity, 10)
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Upsell product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding upsell product to cart:', error);
    });
  }

  // Handle quantity buttons (increase and decrease)
  const qtyMinusButtons = document.querySelectorAll('.qty-minus');
  const qtyPlusButtons = document.querySelectorAll('.qty-plus');
  
  qtyMinusButtons.forEach(button => {
    button.addEventListener('click', function () {
      const qtyField = this.parentElement.querySelector('.qty-field');
      let qty = parseInt(qtyField.value, 10);
      if (qty > 1) {
        qtyField.value = qty - 1;
      }
    });
  });
  
  qtyPlusButtons.forEach(button => {
    button.addEventListener('click', function () {
      const qtyField = this.parentElement.querySelector('.qty-field');
      let qty = parseInt(qtyField.value, 10);
      qtyField.value = qty + 1;
    });
  });
});

// menu-hover js 
$('.mega-menu').hover(
    function() {
      // mouse enter
      $(this).attr('open', true);
    },
    function() {
      // mouse leave
      $(this).removeAttr('open');
    }
  );